module.exports = __webpack_public_path__ + "img/bs_silo_4.c288e084.png";